import { useCallback, useMemo } from 'react';
import { ValidationService } from '../services';

export const useScheduleValidation = (allSchedulesCollection, validationErrors, requiredFields) => {
    const validateAllSchedules = useCallback(() => {
        return ValidationService.validateScheduleCollection(
            allSchedulesCollection,
            validationErrors,
            requiredFields
        );
    }, [allSchedulesCollection, validationErrors, requiredFields]);

    const validationResult = useMemo(() => {
        return validateAllSchedules();
    }, [validateAllSchedules]);

    const getMissingFieldsMap = useCallback(() => {
        return ValidationService.createMissingFieldsMap(validationResult);
    }, [validationResult]);

    const isFieldMissing = useCallback((record, fieldName) => {
        const missingFieldsMap = getMissingFieldsMap();
        const fieldKey = `${record.id || record._emptyRowId}_${fieldName}`;
        return missingFieldsMap[fieldKey] || false;
    }, [getMissingFieldsMap]);


    return {
        isFieldMissing,
    };
};
